import { EndorsementState } from "./types";

export const defaultState = (): EndorsementState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    endorsements: [],
    allEndorsements: [],
    waterCraftOptions: [],
    links: {}
  };
};

export const state = defaultState();
